<template>
  <div id="neuron-images" :class="classes">
    <div v-for="n in 21" :key="n" class="neuron-wrapper">
      <!-- <transition name="fade"> -->
        <img :src="getImgPath(n-1)" v-show="n-1 == year" :alt="altText[n-1]" />
      <!-- </transition> -->
    </div>
  </div>
</template>
<script>
import yearListenerMixin from '@/mixins/yearListenerMixin';

export default {
  name: "NeuronImages",
  props: ['classes'],
  mixins: [yearListenerMixin],
  data() {
    return {
      altText: [
        'Neuronal model with no signs of neuroinflammation or neurodegeneration.',
        'Neuronal model with damage to the myelin sheath.',
        'Neuronal model with damage to the myelin sheath.',
        'Neuronal model with diffuse axonal damage and damage to the myelin sheath.',
        'Neuronal model with axonal damage and partial remyelination.',
        'Neuronal model showing continued changes to the axon terminals and myelin sheath.',
        'Neuronal model showing continued changes to the axon terminals and myelin sheath.',
        'Neuronal model showing continued changes to the axon terminals and myelin sheath.',
        'Neuronal model showing continued changes to the axon terminals and myelin sheath.',
        'Neuronal model reflecting chronic axonal demyelination and other changes.',
        'Neuronal model reflecting chronic axonal demyelination and other changes.',
        'Neuronal model reflecting chronic axonal damage and dissection.',
        'Neuronal model reflecting chronic axonal damage and dissection.',
        'Neuronal model reflecting chronic axonal damage and dissection.',
        'Neuronal model reflecting chronic axonal damage and dissection.',
        'Neuronal model reflecting chronic axonal damage and dissection.',
        'Neuronal model reflecting chronic axonal damage, dissection, and atrophy of the neuronal soma.',
        'Neuronal model reflecting chronic axonal damage, dissection, and atrophy of the neuronal soma.',
        'Neuronal model reflecting complete demyelination, axonal dissection, and atrophy of the neuronal soma.',
        'Neuronal model reflecting complete demyelination, axonal dissection, and atrophy of the neuronal soma.',
        'Neuronal model reflecting complete demyelination, axonal dissection, and atrophy of the neuronal soma.',
       ]
    }
  },
  methods : {
    getImgPath(index) {
      return require(`../assets/img/neurons/neuron_${index}.png`);
    }
  }
}
</script>

<style lang="scss">
  #neuron-images {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    @media (max-width: 625px) {
      top: 20px;
    }
    @media (max-width: 450px) {
      top: 50px;
    }
    .neuron-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }

    &.relative {
      position: relative;

      .neuron-wrapper {
        position: relative;
      }
    }
  }
</style>
